import { Observable } from 'rxjs';
import { Socket } from '../socket-io/socket-io.service';
import { IdVerificationEvents } from './id-verification-events.enum';

export class IdVerificationSocket extends Socket {

  // Tracks whether the operator has opened the manual queue view,
  // so we can re-join the room automatically on reconnect.
  private inManualQueue = false;

  override onConnection() {
    super.onConnection();

    if (this.inManualQueue) {
      this.ioSocket.emit('joinManualQueue');
    }
  }

  // ---- User verification list room ----  
  joinClientRoom(civilId: string, brand: string): void {
    this.ioSocket.emit('joinClientRoom', { civilId, brand });
  }

  leaveClientRoom(civilId: string, brand: string): void {
    this.ioSocket.emit('leaveClientRoom', { civilId, brand });
  }

  onVerificationAdded(): Observable<void> {
    return this.fromEvent<void>('verification:added');
  }

  // ---- Per-verification room ----

  joinVerificationRoom(verificationId: number) {
    this.ioSocket.emit('joinVerificationRoom', verificationId);
  }

  leaveVerificationRoom(verificationId: number) {
    this.ioSocket.emit('leaveVerificationRoom', verificationId);
  }

  onVerificationUpdated(): Observable<any> {
    return this.fromEvent<any>(IdVerificationEvents.VERIFICATION_UPDATED);
  }

  // ---- Manual queue room ----

  joinManualQueue() {
    this.inManualQueue = true;
    this.ioSocket.emit('joinManualQueue');
  }

  leaveManualQueue() {
    this.inManualQueue = false;
    this.ioSocket.emit('leaveManualQueue');
  }

  onQueueInitial(): Observable<any[]> {
    return this.fromEvent<any[]>(IdVerificationEvents.QUEUE_INITIAL);
  }

  onQueueItemAdded(): Observable<any> {
    return this.fromEvent<any>(IdVerificationEvents.QUEUE_ITEM_ADDED);
  }

  onQueueItemRemoved(): Observable<{ verificationId: number }> {
    return this.fromEvent<{ verificationId: number }>(IdVerificationEvents.QUEUE_ITEM_REMOVED);
  }

  onQueueStaleItems(): Observable<any[]> {
    return this.fromEvent<any[]>(IdVerificationEvents.QUEUE_STALE_ITEMS);
  }
}